import { uploadFile } from '@/api/advertiser'
import api from '@/config/api'
import { getKvData } from '@/api/open'

export default {
    components: {
    },
    props: {
        showUploadForm: {
            type: Boolean,
            required: true
        },
    },
    data () {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
            model: {
                file: null,
                email: null,
            },
            fileList: [],
            uploading: false,
            rules: {
                file: [ { required: true, message: '请选择表格文件', trigger: 'change' }],
                email: [ { required: true, message: '请选择邮箱', trigger: 'change' }],
            },
            isTypeDisabled: true,
            url: api.baseUrl + `/设置广告主邮箱模版.xlsx`,
            emails: {}
        }
    },
    computed: {},
    mounted () {
        getKvData({type:5, corporation_id: 1}).then(res => {
            this.emails = Object.keys(res.data || {}).map(key => ({
                id: key,
                name: key
            }))
        })
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.upload()
            });
        },
        upload() {
            this.loading = true
            const data = new FormData()
            data.append('file', this.model.file)
            data.append('email', this.model.email)
            uploadFile(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(`邮箱成功修改${res.data.success_count}条数据`)
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
        },
        beforeUpload(file) {
            this.fileList = [file];
            this.model.file = file
            return false;
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showUploadForm', false)
        }
    }
}
